import React from 'react';
import { Tooltip } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Notification } from 'new/entities/Notification';
import {
  useTriageLauncher,
  buildTriageContextFromResource,
} from 'new/components/monitor/TriageChat';
// Reuse the Flow Insights pill styling so the two sit side by side as matching
// chips in the notification row.
import s from 'new/elements/FlowInsightsNavigationButton/FlowInsightsNavigationButton.module.scss';

const TRIAGEABLE: Notification['resource_type'][] = ['SOURCE', 'DATA_SET', 'DATA_SINK'];

export function NotificationTriageButton({ notification }: { notification: Notification }) {
  const triage = useTriageLauncher();
  const { level, resource_id, resource_type, message } = notification ?? ({} as Notification);
  if (!triage.enabled) return null;
  if (level !== 'ERROR' || !resource_id || !TRIAGEABLE.includes(resource_type)) return null;
  return (
    <Tooltip title="Triage with AI">
      <button
        type="button"
        className={s.button}
        aria-label="Triage with AI"
        data-testid="triage-notification-button"
        onClick={(e) => {
          e.stopPropagation();
          triage.open(
            buildTriageContextFromResource({
              resourceType: resource_type,
              resourceId: resource_id,
              errorSummary: message,
            }),
            'notification_panel',
          );
        }}
      >
        <AutoAwesomeIcon sx={{ fontSize: 14 }} />
        AI Triage
      </button>
    </Tooltip>
  );
}
